import { useState, useEffect } from 'react'
import { Button } from 'primereact/button'
import { InputNumber } from 'primereact/inputnumber'
import { Slider } from 'primereact/slider'
import { Dropdown } from 'primereact/dropdown'
import { ProgressBar } from 'primereact/progressbar'
import { useAtomValue } from 'jotai'
import { toastAtom } from '@/atoms/toastAtom'
import { useLongTask } from '@/utils/longtask'
import { useMutationTaskWithProgress, useTaskWithProgress } from '@/api/hooks/useTaskWithProgress'
import { HelloQueryParams } from '@/api/queries'
import { HelloResponse, HelloService } from '@/api'
import ResultWithProgress from '@/components/ResultWithProgress'

function DataProcessing() {
  const [count, setCount] = useState(10)
  const [wait, setWait] = useState(100)
  const [selectedOption, setSelectedOption] = useState(null)
  const toast = useAtomValue(toastAtom)

  const task1 = useMutationTaskWithProgress<HelloResponse, [boolean,number]>(
    () => {
      return HelloService.helloApiHelloGet(false, count * wait)
    },
    {}
  )
  const task2 = useMutationTaskWithProgress<HelloResponse, [boolean,number]>(
    () => {
      return HelloService.helloApiHelloGet(false, count * wait)
    },
    {}
  )

  console.log("task1", task1.isSuccess, task1.isError, task1.isObserving, task1.progress)
  const options = [
    { name: 'タスク1', value: 'task1' },
    { name: 'タスク2', value: 'task2' }
  ]

  const startProcess = async () => {
    if(selectedOption === "task1"){
      task1.mutateAsync([false, count * wait])
    } else if(selectedOption === "task2"){
      task2.mutateAsync([false, count * wait * 2])
    } else {
      toast?.show({
        severity: 'error',
        summary: 'エラー',
        detail: '処理タイプを選択してください',
        life: 3000
      })
    }
  }

  useEffect(() => {
    if (task1.isSuccess) {
      toast?.show({
        severity: 'success',
        summary: '処理完了',
        detail: `処理1が正常に完了しました ${task1.data?.message}`,
        life: 3000
      })
    }
  }, [task1.isSuccess])

  useEffect(() => {
    if (task2.isSuccess) {
      toast?.show({
        severity: 'success',
        summary: '処理完了',
        detail: `処理2が正常に完了しました ${task2.data?.message}`,
        life: 3000
      })
    }
  }, [task2.isSuccess])

  return (
    <div className="flex flex-column align-items-center">
      <h2 className="text-primary text-xl mb-3">データ処理</h2>
      <p className="text-lg mb-4">
        バックグラウンド処理のデモ
      </p>

      <div className="grid formgrid p-fluid w-full max-w-30rem">
        <div className="field col-12 md:col-6 mb-3">
          <label htmlFor="count">処理回数: {count}</label>
          <InputNumber id="count" value={count} onChange={(e) => setCount(e.value ?? 10)} min={10} max={100} />
          <Slider value={count} onChange={(e) => {
            const newValue = Array.isArray(e.value) ? e.value[0] : e.value;
            setCount(newValue ?? 10);
          }} min={10} max={100} className="mt-2" />
        </div>

        <div className="field col-12 md:col-6 mb-3">
          <label htmlFor="wait">待機時間(ms): {wait}</label>
          <InputNumber id="wait" value={wait} onChange={(e) => setWait(e.value ?? 100)} min={10} max={2000} />
          <Slider value={wait} onChange={(e) => {
            const newValue = Array.isArray(e.value) ? e.value[0] : e.value;
            setWait(newValue ?? 100);
          }} min={10} max={2000} className="mt-2" />
        </div>

        <div className="field col-12 mb-3">
          <Dropdown
            value={selectedOption}
            onChange={(e) => setSelectedOption(e.value)}
            options={options}
            optionLabel="name"
            placeholder="処理タイプを選択"
            className="w-full"
          />
        </div>

        <div className="field col-12 mb-3 flex justify-content-center">
          <Button
            icon="pi pi-cog"
            label="処理開始"
            severity="success"
            onClick={startProcess}
            disabled={task1.isObserving && task2.isObserving}
          />
        </div>
      </div>

      <div className="flex flex-column align-items-center tw-w-[80%]">
        <ResultWithProgress
          isObserving={task1.isObserving}
          progress={task1.progress}
          lastLog={task1.lastLog}
          logs={task1.logs}
          isError={task1.isError}
          error={task1.error}
        />
        <ResultWithProgress
            isObserving={task2.isObserving}
            progress={task2.progress}
            lastLog={task2.lastLog}
            logs={task2.logs}
            isError={task2.isError}
            error={task2.error}
          />
      </div>
    </div>
  )
}

export default DataProcessing
